// Modules
import './Iframe.scss';
import IframeResizer from 'iframe-resizer-react';

type IframeProps = React.ComponentProps<typeof IframeResizer>;

const Iframe = (props: IframeProps) => {
	return <IframeResizer checkOrigin={true} loading="lazy" {...props}></IframeResizer>;
};

export { Iframe };
